export default __webpack_public_path__ + "static/char-s-sp02-cht-ee4ae0ab5257a7de9fb878d753c014f6.png";